"use client";
import { useSyncExternalStore } from "react";
import { SearchField } from "@softmax/web-ux/search";
import { FeatureLink as Link } from "../../navigation/feature-link";
import {
  maxQueryChars,
  platformShortcutHint,
  type SiteSearchCoworldContext,
} from "./search-input";
import { useSearchRow } from "./use-search-row";

const subscribeShortcutHint = () => () => {};
const serverShortcutHint = () => null;

export function SearchRow({
  coworld,
  variant,
  onNavigate,
}: {
  readonly coworld?: SiteSearchCoworldContext | undefined;
  readonly variant: "rail" | "masthead" | "drawer";
  readonly onNavigate?: () => void;
}) {
  const { draft, inputRef, activationHref, activate, changeQuery, leave } =
    useSearchRow({ coworld, onNavigate });
  const shortcutHint = useSyncExternalStore<string | null>(
    subscribeShortcutHint,
    () => platformShortcutHint({}),
    serverShortcutHint,
  );

  if (!draft.active) {
    return (
      <SearchField
        active={false}
        variant={variant}
        href={activationHref}
        shortcutHint={shortcutHint}
        onActivate={activate}
        renderLink={(props) => <Link {...props} />}
      />
    );
  }

  return (
    <SearchField
      active
      variant={variant}
      query={draft.query}
      inputRef={inputRef}
      onQueryChange={(value) => {
        // The API cap counts Unicode code points, unlike an input's maxLength.
        changeQuery([...value].slice(0, maxQueryChars).join(""));
      }}
      onClear={() => {
        if (draft.query.trim() === "") leave();
        else {
          changeQuery("");
          inputRef.current?.focus();
        }
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter") event.preventDefault();
        else if (event.key === "Escape") {
          event.preventDefault();
          leave();
        }
      }}
    />
  );
}
